<template>
  <div class="checkout-empty">
    <div class="checkout-empty-image-wrapper">
      <img src="/assets/images/checkout/empty.svg">
    </div>

    <div class="checkout-empty-info">
      <div class="checkout-empty-info__title">Ваша корзина пуста</div>
      <div class="checkout-empty-info__description">Для начла покупок перейдите в каталог</div>
      <a href="/catalog/" class="checkout-empty-info__action btn-main">В каталог</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutEmpty"
}
</script>

<style scoped>

</style>